export enum ReferencesFilter {
  INFO_REQUIRED = 'INFO_REQUIRED',
  IN_REVIEW = 'IN_REVIEW',
  GUARANTOR_REQUIRED = 'GUARANTOR_REQUIRED'
}

export enum ReferencesSort {
  CREATED_AT = 'CREATED_AT'
}
